import { Pagination } from '~/models/search/types'
import { SchemaField } from '~/models/form/types'
import { ActionResult } from '~/models/shared/result'

interface ByUser {
  id: number | string
  username: string
}

export interface Reason {
  id: number | string
  title: string
  supportCategory: boolean
}

export enum BlacklistReason {
  SUSPICIOUS = 29,
  FRAUDSTER = 18
}

export interface Blacklist {
  byUser: ByUser
  created: string
  groupId: number
  notes: string
  reason: Reason
  site: string
  reasonId: number
  byUserId: number
}

export interface Intent {
  ident: string
  created: string
  vehicles: number
  realEstate: number
  partsXyma: number
  lastSeen: string
}

export interface BlacklistInfo {
  blacklist: Blacklist
  blacklistReasons: Reason[]
  cannotBeBlacklisted: boolean
  idents: string[]
  blacklistCategories: number[]
  blacklistCategoriesNames: string[]
}

export interface BlacklistActionInfo {
  blacklist: Blacklist
  message: string
}

export interface BlacklistInformUsersInfo {
  notifiedNumber: number
}

export interface BlacklistExtras {
  reasonsWithBlacklistCategories: number[]
}

export interface AdminBlacklistIdentsAndGroupsResult {
  blacklists: {
    pagination: Pagination
    rows: Blacklist[]
  }
  group: {
    id: number | null
    idents: Intent[]
    adminNotes: string
  }
  extras: BlacklistExtras
  schema: {
    notes: SchemaField
    ident: SchemaField
    blacklistCategories: SchemaField
    reasonId: SchemaField
  }
}

export interface IdentSchemaResult {
  schema: {
    ident: SchemaField
  }
}

export interface AdminBlacklistGroupNotesResult {
  adminNotes: string
  notes: string
  schema: {
    notes: SchemaField
    adminNotes: SchemaField
  }
}

export interface AdminBlacklistGroupNotesUpdateResult {
  adminNotes: string
  notes: string
}

export interface AdminBlacklistBreakGroupResult {
  idents: string[]
  newGroupId: number
  oldGroupId: number
}

export interface AddBlacklistGroupResult extends ActionResult {
  data: {
    blacklist: {
      byUserId: number
      groupId: number
      notes: string
      reasonId: number
      site: string
    }
  }
}
